// journal-lease.ts
//
// Tách THUẦN từ event-journal.ts (phase 10, lô A): lease writer đơn giữa các
// TIẾN TRÌNH (`locks/journal.lock`, O_EXCL) — leaf, không phụ thuộc class
// `EventJournal`.

import { promises as fs } from "node:fs";

export class JournalLeaseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "JournalLeaseError";
  }
}

export async function fileExists(path: string): Promise<boolean> {
  try {
    await fs.stat(path);
    return true;
  } catch {
    return false;
  }
}

/**
 * Lease writer đơn giữa các TIẾN TRÌNH: `open(wx)` nguyên tử. KHÔNG steal theo tuổi
 * file — journal là dữ liệu không thể mất; lease mồ côi phải do người/doctor gỡ, để
 * không bao giờ có hai writer cùng fd 'a' trên một journal.
 */
export async function acquireJournalLease(leasePath: string): Promise<void> {
  try {
    const handle = await fs.open(leasePath, "wx");
    try {
      await handle.writeFile(
        JSON.stringify({ pid: process.pid, acquiredAt: new Date().toISOString() }),
      );
    } finally {
      await handle.close();
    }
  } catch (err) {
    if ((err as NodeJS.ErrnoException).code === "EEXIST") {
      throw new JournalLeaseError(
        `Journal đang được writer khác giữ (lease: ${leasePath}). ` +
          "Chạy `avatar autopilot unlock` (hoặc xoá lease bằng tay sau khi kiểm tra).",
      );
    }
    throw err;
  }
}
